module.exports = __webpack_public_path__ + "img/four.abbc181c.png";